module.exports = `${require.publicPath}download-img01.3a96cec8.png`;